import React from 'react';

import './PickXProvincesAndTerritories.style.scss';

const PickXProvincesAndTerritories = () => {
    const usStates = [
        "Alabama", "South Carolina", "Alaska", "South Dakota", "Arizona",
        "Tennessee", "Arkansas", "Texas", "Connecticut", "Utah", "California",
        "Vermont", "Delaware", "Virginia", "District of Columbia", "West Virginia",
        "Georgia", "Wisconsin", "Illinois", "Indiana", "Massachusetts", "Minnesota",
        "Missouri", "Nebraska", "New Hampshire", "New Mexico", "North Carolina",
        "North Dakota", "Oklahoma", "Rhode Island"
    ];

    const canadianProvinces = [
        "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
        "Northwest Territories", "Nova Scotia", "Nunavut", "Prince Edward Island", "Quebec",
        "Saskatchewan", "Yukon"
    ];

    const renderTable = (title, items) => (
        <div className={"table-container "+ title }>
            <div className="table-header gold-gradient-text">{title}</div>
            <div className="table-list table-columns">
                {items.sort().map((item, index) => (
                    <div key={index} className="table-item">
                        {item}
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="PickXProvincesAndTerritories">
            <a name="where-is-PickX-available"></a>
            <div className="lastUpdated gold-gradient-text">Last updated 10/1/24</div>
            {renderTable("United-States", usStates)}
            {renderTable("Canada", canadianProvinces)}
        </div>
    );
};

export default PickXProvincesAndTerritories;